import BaseMesh from './BaseMesh.js';
import renderElement from './renderElement.js';
import Line from './elements/Line.js';

class Index extends BaseMesh {
  constructor(data) {
    super(data);
    this._lineElement = null;
    // 渲染并添加 children
    const points = [];
    let lineIndex = 0;
    const isLinkLine = data.props?.isLinkLine ?? false;
    data.children.forEach(elementData => {
      const element = renderElement(elementData);
      element && this.add(element);

      // 添加画线的顶点
      const props = elementData.props;
      const position = props?.position ?? '';
      position && isLinkLine && points.push(position);
      !lineIndex && (lineIndex = (props?.zIndex ?? 2) - 1);
    });
    if (isLinkLine) {
      const lineData = data.props?.line ?? {};
      lineData['points'] = points;
      const lineVisible = lineData?.visible ?? true;
      const linePosition = lineData?.position ?? [0, 0, 1];
      const lineType = lineData?.lineType ?? 'basic';
      const lineStyle = lineData?.lineStyle ?? {};
      const props = {
        points: lineData['points'],
        interactive: true,
        visible: lineVisible,
        zIndex: lineIndex,
        position: linePosition,
        lineType,
        ...lineStyle
      };
      this._lineElement = new Line({ props });
      this._lineElement && this.add(this._lineElement);
    }
  }
  getLineElement() {
    return this._lineElement;
  }
}

export default Index;
